module.exports = __webpack_public_path__ + "img/obiadyIcon.3ba09c41.svg";